export default __webpack_public_path__ + "static/media/food-footer-icon.d631a576.svg";